import { useDispatch } from "react-redux";
import { setSnackbar } from "../../actions/snackbar.actions";
import { useState } from "react";
import { Button, Icon, Modal, Popup } from "semantic-ui-react";
import { sysAPI } from "../../apis/SysAPI";

const RemoveIntegration = ({clientId, integration, refreshFunction, disabled = false}) => {
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleRemoveIntegration = async () => {
        setLoading(true)
        try {
            const {data} = await sysAPI.post('/remove-integration-clients', {
                clients: [clientId],
            })
            dispatch(setSnackbar({message: data.message || "integration removed 🫱🏼‍🫲🏽"}))
            if(refreshFunction){
                await refreshFunction()
            }
            setOpenModal(false)
        } catch (error) {
            console.error({error})
            const message = error?.response?.data?.message || error.message || "There was an error"
            dispatch(setSnackbar({message, status: "error"}))
        }
        setLoading(false)
    }


    if(!integration?.origin){
        return <></>
    }


    return <>
        <Popup
            on={['hover']}
            trigger={
                <Icon
                    disabled={disabled || loading}
                    name="sitemap"
                    style={{cursor:"pointer"}} size="large"
                    onClick={() => setOpenModal(true)}
                />
            }
            content={'Remove integration'}
            inverted
        />

        <Modal size="tiny" open={openModal} onClose={() => setOpenModal(false)} onOpen={() => setOpenModal(true)}>
            <Modal.Header>
                Remove {integration.origin} integration
            </Modal.Header>
            <Modal.Content>
                <div style={{display: "grid", gap: "10px"}}>
                    <div>
                        Are you sure you want to remove <strong>{integration.origin}</strong> integration?
                    </div>
                    <div>
                        This action cannot be undone
                    </div>
                </div>
                </Modal.Content>
            <Modal.Actions>
            <Button onClick={() => setOpenModal(false)} disabled={loading}>Cancel</Button>
            <Button onClick={() => handleRemoveIntegration()} color="orange" loading={loading}>
                Remove it
            </Button>
            </Modal.Actions>
        </Modal>
    </>
}

export default RemoveIntegration